import { User, Member } from '@quick/client';
import smartlookClient from 'smartlook-client';
import { env } from '../configs/EnvironmentConfig';

if (env.REACT_APP_SMARTLOOK_KEY) {
  smartlookClient.init(env.REACT_APP_SMARTLOOK_KEY);
}

export const identifySmartlook = (user: User, member?: Member) => {
  smartlookClient.identify(user.userId.toString(), {
    email: user.email,
    // @ts-ignore
    name: member?.name,
    // @ts-ignore
    memberId: member?.memberId,
    // @ts-ignore
    memberEmail: member?.email,
    // @ts-ignore
    communityId: member?.communityId,
  });
};

export const resetSmartlook = () => {
  smartlookClient.anonymize();
};
